import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = { class: "content-inner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-tip" }, "提示", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "付费服务提醒：当前设备已过保且无增值服务，获取技术支持服务需收取一定服务费用。", -1)
const _hoisted_6 = { class: "footer-inner-wrap" }

import { Popup} from 'vant'
import {computed} from 'vue'
import TechnicalTip from '@/assets/malfunction-repair/technical-tip.png'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'apply-technical-support',
  props: {
    visible: { type: Boolean, default: false },
    guid: null,
    isPlant: { type: Boolean },
    workGuid: null
  },
  emits: ['update:visible'],
  setup(__props: any, { emit }) {

const props = __props as { visible: boolean, guid: string, isPlant: boolean, workGuid: string };



const router = useRouter()



function showHandle (val: boolean) {
  emit('update:visible', val)
}

const pHeightMax = computed(() => {
  const height = window.innerHeight
  return height * 0.9
})

function btnHandle (type: string) {
  if (type === 'cancel') {
    showHandle(false)
  }else if (type === 'apply') {
    showHandle(false)
    router.push({
      name: 'malfunction-repair-duty-result-appeal',
      query: {
        guid: props.guid,
        isPlant: String(props.isPlant),
        from:'payDuty',
        workGuid: props.workGuid,
      },
    })
  }

}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: __props.visible,
    "onUpdate:show": [
      _cache[2] || (_cache[2] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      _cache[3] || (_cache[3] = (value) => showHandle(value))
    ],
    round: "",
    position: "bottom",
    style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            width: "48",
            height: "48",
            src: _unref(TechnicalTip)
          }, null, 8, _hoisted_3),
          _hoisted_4,
          _hoisted_5
        ]),
        _createVNode(CommonFooterWrap, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "cancel-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (btnHandle('cancel')))
              }, "暂不申请"),
              _createElementVNode("div", {
                class: "apply-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (btnHandle('apply')))
              }, "进入付费定责申请")
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show", "style"]))
}
}

})